import React, { useContext } from "react";
import { Check, X } from "react-feather";
import { AuthContext } from "../../Context/AuthContext";
import { DataContext } from "../../Context/DataContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";

const Pricing = () => {
  const { transitionTo } = useScreenTransition();

  const { signedIn } = useContext(AuthContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData.accountType === "personal" || !userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    } else if (
      signedIn &&
      (userData.accountType === "business" || userData.teamId)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    }
  };

  return (
    <div className="pt-20 grid grid-cols-1 md:grid-cols-3 gap-5" id="pricing">
      <div className="px-8 pt-12 space-y-4">
        <h2 className="font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase ">
          Pricing
        </h2>
        <p className="text-[#686F7B] text-base md:w-3/4 w-full">
          We offer certified and standard translation services. Both are
          performed by the same professional translators, but the style and
          deliverables differ.
        </p>
      </div>

      <div className="p-8 bg-white shadow-md rounded-4xl space-y-5">
        <div className="space-y-4">
          <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
            Certified
          </h2>
          <p className="text-base text-[#686F7B]">
            Includes a signed certificate of accuracy, accepted by USCIS,
            courts, universities and government agencies.
          </p>
          <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
            $24.95&nbsp;/ <span className="text-2xl">USD page</span>
          </h2>
        </div>

        <div>
          <p className="font-semibold text-tertiary text-base">General Features</p>
          <ul className="flex gap-4 flex-col mt-4">
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Interpretative
            </li>
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              DOCX Delivery Format
            </li>
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Professional Translation
            </li>
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Revisions Included
            </li>
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Optional Formatting
            </li>
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Signed/Stamped Certification
            </li>
          </ul>
        </div>

        <div>
          <p className="font-semibold text-tertiary text-base">
            Optional Features
          </p>
          <ul className="flex gap-4 flex-col mt-4">
            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Expedited Turnaround
            </li>

            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Notarization
            </li>

            <li className="text-tertiary text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Hard Copy
            </li>
          </ul>
        </div>

        <div>
          <button
            className="bg-primary text-white px-4 py-2 rounded-full hover:opacity-80 font-semibold  w-full whitespace-nowrap"
            onClick={(e) => gotoOrder(e)}
          >
            Create Order
          </button>
        </div>
      </div>

      <div className="p-8 bg-tertiary shadow-md rounded-4xl space-y-5">
        <div className="space-y-4">
          <h2 className="font-secondary font-medium md:text-4xl text-3xl text-white">
            Standard
          </h2>
          <p className="text-base text-[#BDC1C9]">
            The same professional human translation without the certificate,
            to understand the content or for internal use.
          </p>
          <h2 className="font-secondary font-medium md:text-4xl text-3xl text-white">
            $24.95&nbsp;/ <span className="text-2xl">USD page</span>
          </h2>
        </div>

        <div>
          <p className="font-semibold text-white text-base">
            General Features
          </p>
          <ul className="flex gap-4 flex-col mt-4">
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Interpretative
            </li>
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              DOCX Delivery Format
            </li>
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Professional Translation
            </li>
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Revisions Included
            </li>
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Optional Formatting
            </li>
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-[#F46350] rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <X className="h-4 w-4 text-white" />
              </span>
              Signed/Stamped Certification
            </li>
          </ul>
        </div>

        <div>
          <p className="font-semibold text-white text-base">
            Optional Features
          </p>
          <ul className="flex gap-4 flex-col mt-4">
            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-primary rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <Check className="h-4 w-4 text-white" />
              </span>
              Expedited Turnaround
            </li>

            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-[#F46350] rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <X className="h-4 w-4 text-white" />
              </span>
              Notarization
            </li>

            <li className="text-white text-base flex gap-4 items-center justify-start">
              <span className="bg-[#F46350] rounded-full overflow-hidden flex justify-center items-center p-0.5">
                <X className="h-4 w-4 text-white" />
              </span>
              Hard Copy
            </li>
          </ul>
        </div>

        <div>
          <button
            className="bg-primary text-white px-4 py-2 rounded-full hover:opacity-80 font-semibold  w-full whitespace-nowrap"
            onClick={(e) => gotoOrder(e)}
          >
            Create Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
